export const validatePassword = (value: string): boolean => {
  return !!(
    value &&
    hasMinChar(value) &&
    hasNumber(value) &&
    hasSpecialChar(value) &&
    hasUpperCase(value) &&
    hasLowerCase(value)
  );
};
const hasMinChar = (value: string): boolean => value.length >= 8;
const hasNumber = (value: string): boolean => /\d/.test(value);
const hasSpecialChar = (value: string): boolean => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value);
const hasUpperCase = (value: string): boolean => /[A-Z]/.test(value);
const hasLowerCase = (value: string): boolean => /[a-z]/.test(value);
export const passwordStrengthCopy =
  'Choose a password that contains a minimum of 8 characters, a special character and at least one number.';

export const pwdCriteria = (pwd: string): any => {
  return {
    hasMinimumCharCount: hasMinChar(pwd),
    hasNumberChar: hasNumber(pwd),
    hasSpecialCharacter: hasSpecialChar(pwd),
    hasUpperCaseChar: hasUpperCase(pwd),
    hasLowerCaseChar: hasLowerCase(pwd)
  };
};
